/**
 * Customer/User Types
 * Matches the backend API structure
 */

export const RoleEnum = {
  CUSTOMER: 'CUSTOMER',
  ADMIN: 'ADMIN',
  SELLER: 'SELLER',
  SC: 'SC',
  SC_EX: 'SC_EX',
};

/**
 * @typedef {Object} Address
 * @property {string} [line1]
 * @property {string} [line2]
 * @property {string} [city]
 * @property {string} [state]
 * @property {string} [postalCode]
 * @property {string} [country]
 */

/**
 * @typedef {Object} Customer
 * @property {string} id
 * @property {string} email
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} [phone]
 * @property {Address} [address]
 * @property {string} role - One of RoleEnum values
 * @property {string} [brandName] - Only for SELLER role
 * @property {string} [createdAt]
 * @property {string} [updatedAt]
 */

/**
 * @typedef {Object} CustomerFormData
 * @property {string} email
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} password
 * @property {string} [confirmPassword]
 * @property {string} [phone]
 * @property {Address} [address]
 * @property {string} role
 * @property {string} [brandName]
 */

/**
 * @typedef {Object} AuthResponse
 * @property {string} token
 * @property {string} email
 * @property {string} role
 */

/**
 * @typedef {Object} LoginCredentials
 * @property {string} email
 * @property {string} password
 */
